// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y0iH","placeholdersHeader":"styles_placeholdersHeader__1Dd0p","editorStyle":"styles_editorStyle__1vKLu","placeholdersBox":"styles_placeholdersBox__2t-9Q"};